<template>
  <a-row :gutter="8">
    <a-col :xs="{ span: 24}" :lg="{ span: 24 }" :xxl="{ span: 12 }">
      <a-card class="m-bottom">
        <span slot="title">Data Kepegawaian</span>
        <a-button
          v-if="getAuth.divisi[0] == 'HRD'"
          slot="extra"
          @click="handleModalEdit()"
        >Ubah Data</a-button>
        <a-row>
          <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Tanggal Masuk</h4>
              <span
                class="m-text-medium m-text-padding-18"
              >{{moment(data.employee.tgl_masuk).format(getDefaultDateFormat)}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Status Karyawan</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.status_karyawan}}</span>
            </div>
            <div v-if="data.employee.status_karyawan.toLowerCase() == 'tetap'" class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Prediksi Pensiun</h4>
              <span class="m-text-medium m-text-padding-18">{{data.profile.pensiun ? moment(data.profile.pensiun).format(getDefaultDateFormat) : "-"}}</span>
            </div>
            <div v-if="data.employee.status_karyawan.toLowerCase() == 'kontrak'" class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Masa Kontrak</h4>
              <span class="m-text-medium m-text-padding-18">
                {{masaKontrak}}
              </span>
              <div v-if="data.employee.end_kontrak" class="m-text-medium m-text-padding-18">
                {{lamaKontrak}}
              </div>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Site</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.site}}</span>
            </div>
            <!-- <div class="m-bottom" v-if="data.employee.career_path!=null">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Career Path</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.career_path ? data.employee.career_path : '-'}}</span>
            </div> -->
            <!-- <div class="m-bottom" v-if="data.employee.career_path =='Fungsional'">
             <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Struktural/Jabatan</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.nama_jabatan ? data.employee.nama_jabatan :'-'}}</span>
            </div> -->

            <!-- <div class="m-bottom">
                <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Struktural/Jabatan</h4>
                <span class="m-text-medium m-text-padding-18">{{ data.employee.nama_jabatan ? data.employee.nama_jabatan : '-' }} || {{ data.employee.jabatan }}</span>
              </div> -->
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Struktural (Jabatan)</h4>
              <span class="m-text-medium m-text-padding-18">{{ data.employee.nama_jabatan ? data.employee.nama_jabatan : '-' }}  </span>
            </div>

            <div class="m-bottom"  v-if="data.employee.eselon =='-'"> 
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Fungsional ( Pangkat )</h4>
              <span class="m-text-medium m-text-padding-18">
                {{ data.employee.nama_pangkat ? data.employee.nama_pangkat : '-' }}
              </span>

            </div>
            <div class="m-bottom"  v-else> 
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Fungsional ( Pangkat )</h4>
              <span class="m-text-medium m-text-padding-18">
                {{ data.employee.nama_pangkat ? data.employee.nama_pangkat : '-' }} 
               ( Golongan {{ data.employee.eselon ? data.employee.eselon : '-' }} )
              </span>

            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Atasan Langsung</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.atasan_langsung}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Work Hours</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.work_hours ? data.employee.work_hours : "-"}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Senioritas</h4>
              <span class="m-text-medium m-text-padding-18">{{data.profile.senioritas}}</span>
            </div>
           <!-- <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Golongan</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.eselon ? data.employee.eselon :'-' }}</span>
            </div> -->
            
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }" style="padding-left:7px">
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Direktorat</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.direktorat || '-'}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Unit Kerja</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.divisi || '-'}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Departemen</h4>
              <span class="m-text-medium m-text-padding-18">{{data.employee.nama_dept}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Kategori</h4>
              <!--<span class="m-text-medium">{{lastKategoriInsentive[0].kategori ? lastKategoriInsentive[0].kategori: '?'}}</span>-->
              <span class="m-text-medium m-text-padding-18">{{lastKategoriInsentive.length > 0 ? lastKategoriInsentive[0].kategori: '?'}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPD</h4>
              <span
                class="m-text-medium m-text-padding-18"
              >{{lastKategoriInsentive.length > 0 ? lastKategoriInsentive[0].ins_pd : '-'}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPD LN</h4>
              <span
                class="m-text-medium m-text-padding-18"
              >{{lastKategoriInsentive.length > 0 ? lastKategoriInsentive[0].ins_pd_ex : '-'}}</span>
            </div>
            <div class="m-bottom">
              <h4 class="m-text-header-thin m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPS</h4>
              <span
                class="m-text-medium m-text-padding-18"
              >{{lastKategoriInsentive.length > 0 ? lastKategoriInsentive[0].ins_ps: '-'}}</span>
            </div>
            <!-- <div class="m-bottom">
              <h4 class="m-remove">Work Hours</h4>
              <span class="m-text-medium">{{data.employee.work_hours}}</span>
            </div> -->
          </a-col>
        </a-row>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24}" :lg="{ span: 24 }" :xxl="{ span: 12 }">
      <a-card>
        <span slot="title">Histori Kepegawaian</span>
        <a-timeline class="m-timeline">
          <a-timeline-item
            v-for="(datadtl, index) in history_2"
            :key="index"
            :color="index === 0? 'green' : 'grey'"
          >
            <a-card>
              <div
                slot="title"
              >{{datadtl.status === 'Resign' ? 'Pegawai Resign' : 
              (datadtl.tgl_mutasi ? ('Pegawai '+ datadtl.status) : 'Tanggal Update')}} (
              {{datadtl.tgl_mutasi ? moment(datadtl.tgl_mutasi).format(getDefaultDateFormat) : moment(datadtl.tgl_update).format(getDefaultDateFormat)}} )</div>
              <a-tag slot="extra" color="green">{{datadtl.status.toUpperCase()}}</a-tag>
              <a-row>
                <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Tanggal Efektif</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.tgl_mutasi ? datadtl.tgl_mutasi : '-'}}</h4>
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Direktorat</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.direktorat ? datadtl.direktorat : '-' }}</h4>
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Unit kerja</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.nama_dept ? datadtl.nama_dept : "-"}}</h4>
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Bidang</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.nama_bidang ? datadtl.nama_bidang :"-" }}</h4>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Site</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.site ? datadtl.site : "-"}}</h4>
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Kategori</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.kategori ? datadtl.kategori :"-"}}</h4>
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPD</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.ins_pd ? datadtl.ins_pd : "-"}}</h4>
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPD LN</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.ins_pd_ex ? datadtl.ins_pd_ex : "-"}}</h4>
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPS</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.ins_ps ? datadtl.ins_ps : "-"}}</h4>
                  <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Work Hours</h4>
                  <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.work_hours ? datadtl.work_hours :"-"}}</h4>
                </a-col>
              </a-row>
              <div class="m-top m-bottom">
                <a-divider :dashed="true" class="m-small" orientation="left"></a-divider>
              </div>
              <a-row>
                <div class="m-card-w-photo ant-card-body">
                  <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
                    <!-- <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Career Path</h4>
                    <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.career_path ? datadtl.career_path :"-" }}</h4> -->
                    <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Struktural(Jabatan)</h4>
                        <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{ datadtl.nama_jabatan ? datadtl.nama_jabatan : "-" }}</h4>
                  </a-col>
                  <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
                    <!-- <div v-if="datadtl.career_path =='Fungsional'">
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Struktural/Jabatan</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.nama_jabatan ? datadtl.nama_jabatan : "-"}}</h4>
                    </div> -->
                    
                     <div  v-if="datadtl.eselon =='-'"> 
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Fungsional(Pangkat)</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.nama_pangkat ? datadtl.nama_pangkat : "-"}} </h4>
                    </div>
                    <div v-else>
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Fungsional(Pangkat)</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.nama_pangkat ? datadtl.nama_pangkat : "-"}} ( Golongan {{datadtl.eselon ? datadtl.eselon :"-"}})</h4>
                    </div>
                    <!-- <div v-else>
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Struktural/Jabatan</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{datadtl.nama_jabatan ? datadtl.nama_jabatan :"-"}} | Golongan {{datadtl.eselon ? datadtl.eselon :"-"}}</h4>
                    </div> -->
                  </a-col>
                </div>
              </a-row>
            </a-card>
          </a-timeline-item>
          <a-timeline-item color="red"
          :key="history.length"
          >
            <a-card>
              <div
                slot="title"
              >{{'Pegawai Masuk ( ' + (data.history ? moment(data.history[data.history.length - 1].tgl_mutasi).format(getDefaultDateFormat) : "") + " )"}}</div>
              <a-tag slot="extra" color="green" v-if="data.history">{{ (data.history ? data.history[data.history.length-1].status.toUpperCase() : "")}}</a-tag>
              <a-row>
                <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
                  <div>
                    <div>
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Tanggal Efektif</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{ (data.history ? data.history[data.history.length - 1].tgl_mutasi : "")}}</h4>
                    </div>
                    <div>
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Direktorat</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{ (data.history ? data.history[data.history.length - 1].direktorat : "")}}</h4>
                    </div>
                    <div>
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Unit kerja</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{ (data.history ? data.history[data.history.length - 1].nama_dept: "")}}</h4>
                    </div>
                    <div>
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Bidang</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{ (data.history ? data.history[data.history.length - 1].nama_bidang :"")}}</h4>
                    </div>
                  </div>
                </a-col>
                <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
                  <div>
                    <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Site</h4>
                    <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{ (data.history ? data.history[data.history.length - 1].site:"")}}</h4>
                  </div>
                  <div>
                    <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Kategori</h4>
                    <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18">{{ (data.history ? data.history[data.history.length - 1].kategori:"")}}</h4>
                  </div>
                  <div>
                    <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPD</h4>
                    <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{ (data.history ? (data.history[data.history.length - 1].ins_pd ? data.history[data.history.length - 1].ins_pd: '-'):"")}}</h4>
                  </div>
                  <div>
                    <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPD</h4>
                    <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{ (data.history ? (data.history[data.history.length - 1].ins_pd_ex ? data.history[data.history.length - 1].ins_pd_ex: '-'):"")}}</h4>
                  </div>
                  <div>
                    <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Insentive SPPS</h4>
                    <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{ (data.history ? (data.history[data.history.length - 1].ins_ps ? data.history[data.history.length - 1].ins_ps: '-'):"")}}</h4>
                  </div>
                  <div>
                    <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Work Hours</h4>
                    <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{ (data.history ? (data.history[data.history.length - 1].work_hours ? data.history[data.history.length - 1].work_hours: '-'):"")}}</h4>
                  </div>
                </a-col>
              </a-row>
              <div class="m-top m-bottom">
                <a-divider :dashed="true" class="m-small" orientation="left"></a-divider>
              </div>
              <a-row class="m-remove">
                <div class="m-card-w-photo ant-card-body">
                  <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
                    <div>
                      <!-- <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Career Path</h4>
                      <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{data.history[0].career_path}}</h4> -->
                      <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Struktural/Jabatan</h4>
                          <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{ data.history[0].nama_jabatan }}</h4>
                    </div>
                  </a-col>
                  <a-col :xs="{ span: 24}" :lg="{ span: 12 }">
                    <div v-if="data.history">
                      <!-- <div v-if="data.history[0].career_path == 'Fungsional'">
                        <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Struktural/Jabatan</h4>
                        <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{data.history[0].nama_jabatan}}</h4>
                      </div> -->
                      <div >
                        <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Fungsional/Pangkat</h4>
                        <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{data.history[0].nama_pangkat ? data.history[0].nama_pangkat  : "-"}} | Golongan {{data.history[0].eselon ? data.history[0].eselon : "-"}}</h4>
                      </div>
                      <!-- <div v-else>
                        <h4 class="m-text-header m-remove"><a-icon type="right-square" theme="filled" /> Jabatan</h4>
                        <h4 class="m-remove m-padding-left-10 m-text-medium m-text-padding-18" v-if="data.history">{{data.history[0].nama_jabatan}} | Golongan {{data.history[0].eselon}}</h4>
                      </div> -->
                    </div>
                  </a-col>
                </div>
              </a-row>
            </a-card>
          </a-timeline-item>
        </a-timeline>
      </a-card>
    </a-col>

    <a-modal :width="800" title="Edit Data Kepegawaian" :visible="visible" @cancel="handleCancel">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="btnLoading" @click="handleOk">Submit</a-button>
      </template>
      <a-form class="m-form" :form="form">
        <a-row :gutter="8">
          <a-col span="12">
            <a-form-item label="Tanggal Efektif">
              <a-date-picker
                :format="getDefaultDateFormat"
                class="w-full"
                allowClear
                v-decorator="['tglMutasi',{rules: [{required: true}]}]"
              />
            </a-form-item>
            <a-form-item label="Status Karyawan">
              <a-select
                v-decorator="['sts_karyawan', {rules: [{required: true}], initialValue: data.employee.status_karyawan}]"
                @change="changeStatus"
              >
                <a-select-option key="1" value="Tetap">Tetap</a-select-option>
                <a-select-option key="2" value="Kontrak">Kontrak</a-select-option>
                <a-select-option key="3" value="Resign">Resign</a-select-option>
                <a-select-option key="4" value="Habis Kontrak">Habis Kontrak</a-select-option>
                <a-select-option key="5" value="PHK">PHK</a-select-option>
                <a-select-option key="6" value="Pensiun">Pensiun</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if="isKontrak" label="Akhir Kontrak">
              <a-date-picker
                :format="getDefaultDateFormat"
                class="w-full"
                allowClear
                v-decorator="['end_kontrak']"
              />
            </a-form-item>
            <a-form-item v-if="isTetap" label="Prediksi Pensiun">
              {{moment(data.profile.pensiun).format(getDefaultDateFormat)}}
            </a-form-item>
            <a-form-item label="Site">
              <a-select
                v-decorator="['site', {rules: [{required: true}], initialValue: data.employee.site}]"
              >
                <a-select-option key="1" value="surabaya">Surabaya</a-select-option>
                <a-select-option key="2" value="jakarta">Jakarta</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Career Path" hidden>
              <a-select
                v-decorator="['career_path', {rules: [{required: false}], initialValue: data.employee.career_path}]"
                @change="changeCareer_path"
              >
                <a-select-option key="1" value="Struktural">Struktural</a-select-option>
                <a-select-option key="2" value="Fungsional">Fungsional</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Struktural / Jabatan">
              <a-select
                v-decorator="['posisi', {rules: [{required: true}], initialValue: data.employee.id_jabatan}]"
                v-if="!isfungsional"
              >
                <a-select-option
                  v-for="(jabatan, index) in getMaster.posisi"
                  :key="index"
                  :value="jabatan.id_jabatan"
                >{{jabatan.nama_jabatan}} - Golongan {{jabatan.echelon}}</a-select-option>
              </a-select>
              <a-select
                v-decorator="['posisi', {rules: [{required: true}], initialValue: data.employee.id_jabatan}]"
                v-else
              >
                <a-select-option
                  v-for="(jabatan, index) in getMaster.posisi"
                  :key="index"
                  :value="jabatan.id_jabatan"
                >{{jabatan.nama_jabatan}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Nama Jabatan">
              <a-auto-complete
                :dataSource="getMaster.jabatan"
                placeholder="input here"
                v-decorator="['jabatan', {rules: [{required: true}], initialValue: data.employee.jabatan}]"
                :filterOption="handleFilterJabatan"
              />
            </a-form-item>
            <a-form-item label="Fungsional / Pangkat">
              <a-select show-search
                allowClear :filterOption="handleFilterJabatan"
                v-decorator="['grade', { rules: [{required: true}], initialValue: data.employee.id_pangkat}]"
              >
                <a-select-option
                  v-for="pangkat in getMaster.pangkat"
                  :key="pangkat.id_pangkat"
                  :value="pangkat.id_pangkat"
                >{{pangkat.nama_pangkat}} - Golongan {{pangkat.echelon}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col span="12">
            <a-form-item label="Departemen">
              <a-select show-search
                allowClear :filterOption="handleFilterJabatan"
                v-decorator="['id_dept', { initialValue: data.employee.nama_dept}]"
              >
                <a-select-option
                  v-for="departemen in getMaster.departemen"
                  :key="departemen.id_dept"
                  :value="departemen.id_dept"
                >{{departemen.nama_dept}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Divisi">
              <a-select allowClear show-search :filterOption="handleFilterJabatan" v-decorator="['divisi', {initialValue: data.employee.divisi}]">
                <a-select-option
                  v-for="divisi in getMaster.divisi"
                  :key="divisi"
                  :value="divisi"
                >{{divisi}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Atasan Langsung">
              <a-select
                allowClear
                showSearch
                v-decorator="['atasan', {initialValue: data.employee.atasan_langsung}]"
              >
                <a-select-option
                  v-for="atasan in getMaster.list_atasan"
                  :key="atasan"
                  :value="atasan"
                >{{atasan}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Kategori">
              <a-select
                allowClear
                v-decorator="['kategori', {initialValue: data.employee.kategori}]"
              >
                <a-select-option
                  v-for="kategori in getMaster.kategori_pd"
                  :key="kategori.kategori"
                >{{kategori.kategori}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Work Hours">
              <a-select
                allowClear
                v-decorator="['work_hours', {initialValue: data.employee.work_hours}]"
              >
                <a-select-option :key="0" :value="'Fixed'">Fixed</a-select-option>
                <a-select-option :key="1" :value="'Shift'">Shift</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="No. Rekening" v-if="data.dokumen">
              <a-input
                autocomplete="off"
                v-decorator="['no_rek', {initialValue: data.dokumen.no_rekening}]"
              />
            </a-form-item>
            <a-form-item label="Bank" v-if="data.dokumen">
              <a-select
                allowClear
                showSearch
                v-decorator="['bank', { initialValue: data.dokumen.bank}]"
              >
                <a-select-option
                  v-for="bank in getBank"
                  :key="bank.code"
                  :value="bank.name"
                >{{bank.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-row>
</template>

<script>
import _ from "lodash";
import moment from "moment";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "kepegawaian",
  props: ["data"],
  data() {
    return {
      visibleHistory: false,
      visible: false,
      btnLoading: false,
      isfungsional: false,
      isKontrak: false,
      isTetap: false
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.$store.dispatch("Fetch_Bank");
  },
  computed: {
    ...mapGetters([
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getAuth",
      "getMaster",
      "getBank"
    ]),
    history() {
      return _.slice(this.data.history, 1);
    },
    history_2() {
      return this.data.history ? _.slice(this.data.history, 0, this.data.history.length-1) : [];
    },
    lastKategoriInsentive() {
      return _.slice(this.data.history, 0, 1);
    },
    masaKontrak() {
      const start = moment(this.data.employee.tgl_aktif);
      if (this.data.employee.end_kontrak) {
        const end = moment(this.data.employee.end_kontrak);
        return start.format(this.getDefaultDateFormat) + " s/d " 
          + end.format(this.getDefaultDateFormat);
      } else {
        return start.format(this.getDefaultDateFormat) + " s/d -";
      }
    },
    lamaKontrak() {
      const start = moment(this.data.employee.tgl_aktif);
      if (this.data.employee.end_kontrak) {
        const end = moment(this.data.employee.end_kontrak);
        const years = end.diff(start, 'years');
        let months = end.diff(start, 'months');
        if (years > 0) {
          months -= years * 12;
          if (months <= 0) {
            return "("+ years + " tahun)";
          } else {
            return "("+ years + " tahun " + months + " bulan)";
          }
        } else {
          return "("+ months + " bulan)";
        }
      } else {
        return "";
      }
    }
  },
  methods: {
    moment,
    handleFilterJabatan(input, option) {
      return (
        option.componentOptions.children[0].text
          .toUpperCase()
          .indexOf(input.toUpperCase()) >= 0
      );
    },
    handleModalEdit() {
      this.visible = true;
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    handleOk() {
      this.confirmMessage("confirm-save");
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        let departemen = "";

        if (values.id_dept !== undefined) {
          let output = this.getMaster.departemen.filter(
            item =>
              item.nama_dept
                .toUpperCase()
                .indexOf(values.id_dept.toUpperCase()) >= 0 ||
              item.id_dept
                .toUpperCase()
                .indexOf(values.id_dept.toUpperCase()) >= 0
          );

          departemen = output[0].id_dept;
        } else {
          departemen = 0;
        }

        let gl = _.filter(
          this.getMaster.kategori_pd,
          filt =>
            filt.kategori
              .indexOf(values.kategori) >= 0
        );

        let posisiNm = _.filter(
          this.getMaster.posisi,
          filt =>
            filt.id_jabatan
              .indexOf(values.posisi) >= 0
        );

        let glpercentage = parseInt(gl[0].ins_ps) / 100;

        this.btnLoading = true;
        let postData = new FormData();
        
        postData.append("tlc", this.data.profile.tlc);
        postData.append("site", values.site);
        postData.append("id_jabatan", values.posisi);
        postData.append("posisi", posisiNm[0].nama_jabatan);
        if (values.grade)
          postData.append("id_pangkat", values.grade);
        postData.append("jabatan", values.jabatan);
        postData.append("id_dept", departemen);
        postData.append("ins_pd", gl[0].ins_pd_in);
        postData.append("ins_pd_ex", gl[0].ins_pd_ex);
        postData.append("ins_ps", glpercentage);
        postData.append("divisi", values.divisi);
        if (this.isfungsional)
          postData.append("golongan", values.golongan);
        postData.append("kategori", values.kategori);
        postData.append("atasan_langsung", values.atasan);
        postData.append("no_rek", values.no_rek);
        postData.append("bank", values.bank);
        postData.append("status", values.sts_karyawan);
        postData.append("career_path", values.career_path);
        postData.append("work_hours", values.work_hours);

        if (values.tglMutasi !== undefined) {
          postData.append(
            "tgl_mutasi",
            values.tglMutasi.format(this.getStandartFormatDate)
          );
        }
        if (values.end_kontrak !== undefined) {
          postData.append(
            "end_kontrak",
            values.end_kontrak.format(this.getStandartFormatDate)
          );
        }

        axios({
          method: "post",
          url: this.$serviceUrl + "master_karyawan/employee_edit",
          processData: false,
          data: postData,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey
          }
        })
          .then(response => {
            this.displayMessage("success-edit");
            this.form.resetFields('tglMutasi');
            this.btnLoading = false;
            this.visible = false;
            Event.$emit("fetching");
          })
          .catch(err => {
            this.btnLoading = false;
          });
      });
    },
    changeCareer_path(e){
      this.isfungsional = e=="Struktural" ? false : true;
    },
    changeStatus(e){
      this.isKontrak = e && e.toLowerCase() == "kontrak";
      this.isTetap = e && e.toLowerCase() == "tetap";
    }
  },
  mounted() {
    Event.$on("confirmMessageReturn", this.submit);
    if(this.data.employee){
      this.changeCareer_path(this.data.employee.career_path);
      this.changeStatus(this.data.employee.status_karyawan);
    }
  },
  beforeDestroy() {
    Event.$off("confirmMessageReturn", this.submit);
  },
  watch: {
    data(newData, oldData) {
      console.log("STATUS = " + newData.employee.tlc + " - " + newData.employee.status_karyawan);
      this.changeStatus(newData.employee.status_karyawan);
    }
  }
};
</script>

<style>
</style>